import {makeStyles} from '@material-ui/core/styles';

export const storeOrderFormStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
    // margin: '20px 0 20px'
  },
  paper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 20,
    paddingLeft: 0,
    justifyContent: 'space-around'
  },
  finalButton: {
    backgroundColor: '#5b8a72',
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    '&:hover': {
      backgroundColor: '#464f41'
    }
  },
  // inner container
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& div.order-form': {
      width: '100%'
    }
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 20,
    width: '100%',
    marginTop: 20
  },
  line: {
    width: 5,
    height: 28,
    backgroundColor: '#e4002b',
    borderRadius: 1,
    marginRight: 10
  },
  button: {
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  actionsContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));
